import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertController } from '@ionic/angular';

import { AlertInfo, AlertTypes } from '../interfaces/alert.model';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  alert$ = new BehaviorSubject<AlertInfo>(null);
  private readonly duration = 3;

  constructor(private alertController: AlertController) { }

  // -------- messages -----------
  showSuccess(text: string, duration = this.duration): void {
    this.alert$.next({
      text, icon: '<ion-icon name="checkmark"></ion-icon>'
      , type: AlertTypes.Success, duration: duration * 1000
    } as AlertInfo);
  }
  showInfo(text: string, duration = this.duration): void {
    this.alert$.next({ text, icon: "", type: AlertTypes.Info, duration: duration * 1000 } as AlertInfo);
  }

  showWarning(text: string, duration = this.duration): void {
    this.alert$.next({ text, icon: "", type: AlertTypes.Warn, duration: duration * 1000 } as AlertInfo);
  }

  showError(text: string, duration = this.duration): void {
    this.alert$.next({ text, icon: "", type: AlertTypes.Error, duration: duration * 1000 } as AlertInfo);
  }

  // -------- messages -----------
  async showAlert(header: string, message: string) {
    const alert = await this.alertController.create({
      header,
      message,
      buttons: ['OK']
    });

    await alert.present();
  }
}
